import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "@builder/components/editable/EditableInfo";
import { EditableProps } from "@builder/components/editable/editableProps";
import SelectInput from "@builder/components/general/SelectInput";
import TextInput from "@builder/components/general/TextInput";
import Toggle from "@builder/components/general/Toggle";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { setActiveNode, updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { SlideoutNode } from "@common/build/types";

type OpenMode = "pushLeft" | "pushRight" | "overlayLeft" | "overlayRight";

const EditSlideout = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as SlideoutNode;

    //Open mode
    const openModeOptions: Record<OpenMode, string> = {
        pushLeft: "Push out from left",
        pushRight: "Push out from right",
        overlayLeft: "Overlay from left",
        overlayRight: "Overlay from right"
    };
    const openMode = node.slideout?.openMode;
    const openModeCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["slideout", "openMode"], value }));
    };

    //Active
    const active = useAppSelector(state => state.builder.activeNode) === node.id;
    const activeCallback = (checked: boolean) => [dispatch(setActiveNode(checked ? node.id : null))];

    //Title
    const title = node.slideout?.header?.title?.text;
    const titleCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["slideout", "header", "title", "text"], value }));
    };

    //Close button
    const closeButton = node.slideout?.header?.closeButton?.visible || false;
    const closeButtonCallback = (checked: boolean) => [
        dispatch(updateNodeProperty({ propertyPath: ["slideout", "header", "closeButton", "visible"], value: checked }))
    ];

    return (
        <SidebarCollapse title="Slide out" parent={parent}>
            <EditableInfo
                header="slideoutInfoHeader"
                body="slideoutInfoBody"
            />
            <SelectInput title="Open mode" layout="column" value={openMode} options={openModeOptions} callback={openModeCallback} />
            <Toggle label="Show open in builder" checked={active} callback={activeCallback} />
            <TextInput title="Title" placeholder="Enter header title" value={title} callback={titleCallback} />
            <Toggle label="Show close button" checked={closeButton} callback={closeButtonCallback} />
        </SidebarCollapse>
    );
};

export default EditSlideout;
